import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import AppDataLoader from "../components/system/AppDataLoader";
import GlobalLoader from "../components/common/GlobalLoader";

function MainLayout() {
  return (
    <>
      <AppDataLoader />
      <Header />
      <GlobalLoader />
      <Outlet />
      <Footer />
    </>
  );
}

export default MainLayout;
